import SvgLib from '@/components/SvgLib'

export default {
  name: 'CreateLogo',
  template: '#create-logo-template',
  data () {
    return {
      logoWidth: 150,
      uiSliderWidth: 0,
      logosStageWidth: 0,
      logosContainerWidth: 0,
      logosInitOffset: 0,
      dragContainerWidth: 0,
      dragElWidth: 0,
      dragAreaWidth: 0,
      logoCount: 10,
      stepSize: 0,
      modalActive: false,
      theCurrent: this.current,
      logos: [
        'team1',
        'team2',
        'team3',
        'team4',
        'team6',
        'team7',
        'team8',
        'team9',
        'team10',
        'team11'
      ]
    }
  },
  props: [
    'backRoute',
    'current'
  ],
  components: { SvgLib },
  computed: {
    currentLogo () {
      return this.logos[this.theCurrent]
    },
    nextLogo () {
      if (this.theCurrent >= 9) {
        return this.logos[0]
      } else {
        return this.logos[this.theCurrent + 1]
      }
    },
    prevLogo () {
      if (this.theCurrent <= 0) {
        return this.logos[this.logos.length - 1]
      } else {
        return this.logos[this.theCurrent - 1]
      }
    },
    progress () {
      return (this.theCurrent + 1) / this.logos.length
    }
  },
  methods: {
    logoClick (e) {
      let clickedLogo = e.target.dataset.logo
      if (clickedLogo) {
        this.confirmLogo(clickedLogo)
        console.log('clicked: ', clickedLogo)
      }
    },
    changeCurrent (x) {
      let y = this.theCurrent + x

      if (y <= -1) {
        this.theCurrent = this.logos.length - 1
      } else if (y >= this.logoCount) {
        this.theCurrent = 0
      } else {
        this.theCurrent += x
      }
    },
    confirmLogo (logo) {
      let confirmedLogo = typeof (logo) === 'string' ? logo : this.currentLogo
      this.$store.dispatch('setTeamLogo', confirmedLogo)
      this.$router.push(this.backRoute)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/create/CreateLogo.js